/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ difference: NonNullable<unknown>, target: NonNullable<unknown> }} Consumption_Difference_VersusInputs */



/**
* | output |
* | --- |
* | "{difference} vs {target}" |
*
* @param {Consumption_Difference_VersusInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_difference_versus = /** @type {((inputs: Consumption_Difference_VersusInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Difference_VersusInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.difference} vs ${i?.target}`)
	return /** @type {LocalizedString} */ (`${i?.difference} vs ${i?.target}`)
});